import chroma from 'chroma-js';

export type HEX = string;
export type AutoColorCode = {
  hover: string;
  pressed: string;
};

export function getAutoColorCode(color: HEX): AutoColorCode {
  if (!chroma.valid(color)) {
    return {
      hover: color,
      pressed: color,
    };
  }
  const hexToHsv = chroma(color).hsv();
  let hover = color;
  let pressed = color;

  if (hexToHsv[1] >= 0.04) {
    hover = chroma.hsv(hexToHsv[0], hexToHsv[1], hexToHsv[2] - 0.07).hex();
    pressed = chroma.hsv(hexToHsv[0], hexToHsv[1], hexToHsv[2] - 0.14).hex();
  } else {
    hover = chroma.hsv(hexToHsv[0], hexToHsv[1], hexToHsv[2] - 0.03).hex();
    pressed = chroma.hsv(hexToHsv[0], hexToHsv[1], hexToHsv[2] - 0.06).hex();
  }

  return {
    hover,
    pressed,
  };
}
